import { useState, useEffect, } from 'react';
import { i18nLibraryInstance, initializeLibraryI18n } from './library.js';
import { getI18nSSRInstance } from './ssr.js';
/**
 * Get the appropriate i18n instance.
 * Returns SSR instance if available (for SSR/hydration scenarios),
 * otherwise returns the library instance.
 */
function getI18nInstance() {
    const ssrInstance = getI18nSSRInstance();
    if (ssrInstance?.isInitialized) {
        return ssrInstance;
    }
    return i18nLibraryInstance;
}
export const useI18n = (currentLanguage) => {
    const i18nInstance = getI18nInstance();
    // CRITICAL: Always start with false to preserve timing behavior.
    // Some consumers (dashboard-web modals) depend on the render cycle delay
    // from useState(false) → useEffect → setState(true).
    const [isInitialized, setIsInitialized] = useState(false);
    useEffect(() => {
        // If using SSR instance that's already initialized, we're done
        if (i18nInstance.isInitialized) {
            setIsInitialized(true);
            return;
        }
        // Otherwise, initialize the library instance asynchronously
        const initialize = async () => {
            await initializeLibraryI18n();
            setIsInitialized(true);
        };
        initialize();
    }, [i18nInstance]);
    useEffect(() => {
        if (currentLanguage && isInitialized) {
            i18nInstance.changeLanguage(currentLanguage);
        }
    }, [currentLanguage, isInitialized, i18nInstance]);
    return {
        isInitialized,
        i18n: i18nInstance,
    };
};
